module.exports = __webpack_public_path__ + "static/sharing-762766ee56c32aa5ca9576b1c6f89e43.png";